// @ts-strict-ignore
import { addExperimentGroupToTargeting } from '@platforms/shared';
import {
	BaseServiceSetup,
	context,
	defineExperiment,
	Experiment,
	getExperiment,
	utils,
} from '@wikia/ad-engine';
import { Injectable } from '@wikia/dependency-injection';

type RunningExperimentType = Experiment | null | undefined;

const logGroup = 'UcpMobileMoreIcbExperiment';

@Injectable()
export class UcpMobileMoreIcbExperiment extends BaseServiceSetup {
	private pathfinderExperimentVariantNames = {
		control: 'more-icb-control',
		v1: 'more-icb-v1',
	};

	private pathfinderExperimentVariants = [
		defineExperiment({
			name: this.pathfinderExperimentVariantNames.control,
			buckets: ['85', '86', '87'],
		}),
		defineExperiment({
			name: this.pathfinderExperimentVariantNames.v1,
			buckets: ['0', '1', '48'],
		}),
	];

	call(): void {
		this.configure();
	}

	private pathfinderActiveExperimentVariant: RunningExperimentType = getExperiment(
		this.pathfinderExperimentVariants,
	);

	private configure() {
		if (this.isExperimentEnabled() && this.pathfinderActiveExperimentVariant?.name) {
			switch (this.pathfinderActiveExperimentVariant.name) {
				case this.pathfinderExperimentVariantNames.v1:
					utils.logger(logGroup, 'V1 group');
					context.set('experiments.mobileMoreIcb', true);
					addExperimentGroupToTargeting(this.pathfinderExperimentVariantNames.v1);
					break;
				case this.pathfinderExperimentVariantNames.control:
					utils.logger(logGroup, 'Control group');
					context.set('experiments.mobileMoreIcb', false);
					addExperimentGroupToTargeting(this.pathfinderExperimentVariantNames.control);
					break;
			}

			utils.logger(logGroup, 'experiments.mobileMoreIcb', context.get('experiments.mobileMoreIcb'));
		} else {
			utils.logger(logGroup, 'Experiment disabled');
			context.set('experiments.mobileMoreIcb', false);
			return;
		}
	}

	private isExperimentEnabled(): boolean {
		return this.instantConfig.get('icExperiments', []).includes('mobileMoreIcbExperiment');
	}
}
